var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 64,
    viewBox: "0 0 39 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97765 36.4162L11.9818 36.5712L10.4988 39.3605L8.71915 41.9949L7.08785 44.6292L5.45654 47.1086L8.86745 47.5735L12.4267 47.8834L16.1342 48.0384L19.6934 48.1934L23.2526 47.8834L26.8118 47.5735L30.371 46.9537L34.0785 46.0239L32.0023 42.6147L30.2227 39.2055L28.4431 35.7964L31.2608 35.4864L31.1125 32.0773L30.6676 28.5131L30.2227 25.1039L29.6295 21.6948L28.888 18.2856L27.8499 15.0314L26.3669 11.7772L25.1805 8.6779L23.4009 5.73361L21.473 2.78933L19.5451 0L17.3206 2.63436L15.3927 5.57865L13.6131 8.6779L12.1301 11.9321L11.092 15.3413L10.0539 18.7505L9.31235 22.1596L8.71915 25.7238L8.42255 29.2879L8.12595 32.8521L7.97765 36.4162Z",
    fill: "#AB1EBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.858 53.6164L33.0403 52.5316L30.3709 50.982L27.7015 49.2773L23.8457 49.7422L26.0702 53.3064L29.1845 55.9408L32.5954 58.1104L35.5614 57.9554L38.2308 56.5607L38.9723 54.3912L35.858 53.6164Z",
    fill: "#AB1EBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60493 58.1104L8.42264 56.5607L11.092 54.7011L13.6132 52.5316L15.3928 49.7422H11.9819L9.16414 51.2918L6.34643 52.8415L3.38042 53.7713L0.266113 54.3912L1.60082 57.3355L5.60493 58.1104Z",
    fill: "#AB1EBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4393 63.8441L27.4053 63.3792L30.223 62.2944L27.9985 59.3501L25.6257 56.4057L23.4012 53.3064L22.0665 49.7422L19.3971 50.2071L16.876 49.7422L15.0964 53.4614L13.0202 57.0256L10.0542 59.66L11.2406 61.9845L14.5032 63.0692L18.0624 63.8441L21.4733 63.999L24.4393 63.8441Z",
    fill: "#AB1EBA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.514362f677d570c25480ffdede822960.svg";
export { ForwardRef as ReactComponent };